import { React, useEffect, useState } from "react";
import "./App.css";

import logo from "./logo/logo.svg";

// The function that makes the fetch request to the Products API
import { getProducts } from "./services/getProducts";
import ProductList from "./ProductsList";

function App() {
  // use the products variable to read all of your products
  // and display them on your page
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const products = await getProducts();
      setProducts(products);
    };

    loadData();
  }, []);

  return (
    <div className="container">
      <h1>Shop</h1>
      <img src={logo} alt="Logo" />
      <ProductList products={products} />
    </div>
  );
}

export default App;
